import { getPos } from "@/js/common";
export const drag = {
  bind: bindDargEvent,
  update: bindDargEvent,
  unbind: function() {}
};

function bindDargEvent(el, binding) {
  const ele = el;

  if (!ele) return;

  // 拖拽
  ele.onmousedown = function(e) {
    const disX = e.clientX - getPos(ele).left + 1;
    const disY = e.clientY - getPos(ele).top + 1;

    document.onmousemove = function(e) {
      e.stopPropagation();
      e.preventDefault();
      const scale = binding.value.scale;
      const canvas = document.querySelector(".draw-canvas");
      const left = Math.round((e.clientX - disX - getPos(canvas).left) / scale);
      const top = Math.round((e.clientY - disY - getPos(canvas).top) / scale);
      binding.value.element.left = left;
      binding.value.element.top = top;
    };

    clear();
  };

  // 旋转
  const oRotate = ele.querySelector(".rotate-wrapper");
  oRotate.onmousedown = function(ev) {
    ev.stopPropagation();
    // 求中心点的位置
    const centerX = getPos(ele).left + ele.offsetWidth / 2;
    const centerY = getPos(ele).top + ele.offsetHeight / 2;

    document.onmousemove = function(ev) {
      ev.preventDefault();
      const clientX = ev.clientX;
      const clientY = ev.clientY;
      // 弧度转换成角度
      let deg = Math.round(
        (Math.atan2(clientY - centerY, clientX - centerX) * 180) / Math.PI
      );

      if (clientX < centerX && clientY > centerY) {
        // 第三象限
        deg -= 90;
      } else {
        // 其他象限
        deg += 270;
      }
      binding.value.element.rotate = deg;
    };

    clear();
  };

  // 右下角
  const oBottomRight = ele.querySelector(".bottom-right");
  oBottomRight.onmousedown = function(ev) {
    ev.stopPropagation();
    const startX = ev.clientX;
    const startY = ev.clientY;
    // 获取初始值
    const bindingScale = binding.value.scale;
    const { width, height } = binding.value.element;
    let dragScale = 0;
    document.onmousemove = function(ev) {
      ev.preventDefault();
      // 拉伸的距离需要换算成真实距离
      const disX = (ev.clientX - startX) / bindingScale;
      const disY = (ev.clientY - startY) / bindingScale;

      // 谁大用谁比
      dragScale = disX > disY ? disX / width : disY / height;

      const w = width * (dragScale + 1);
      const h = height * (dragScale + 1);
      if (w < 0 || h < 0) return;
      binding.value.element.width = w;
      binding.value.element.height = h;
    };

    clear();
  };

  // 右中心点
  const oRight = ele.querySelector(".right");
  oRight.onmousedown = function(ev) {
    ev.stopPropagation();
    const startX = ev.clientX;
    const bindingScale = binding.value.scale;
    const { width } = binding.value.element;
    let dragScale = 0;
    document.onmousemove = function(ev) {
      ev.preventDefault();
      const disX = (ev.clientX - startX) / bindingScale;
      dragScale = disX / width;
      const w = width * (dragScale + 1);
      if (w < 0) return;
      binding.value.element.width = w;
    };
    clear();
  };

  // 右上角 以左下角为固定点需要算 top
  const oTopRight = ele.querySelector(".top-right");
  oTopRight.onmousedown = function(ev) {
    ev.stopPropagation();
    const startX = ev.clientX;
    const startY = ev.clientY;
    const bindingScale = binding.value.scale;
    const { width, height, top } = binding.value.element;
    let dragScale = 0;
    document.onmousemove = function(ev) {
      ev.preventDefault();
      const disX = (ev.clientX - startX) / bindingScale;
      const disY = -(ev.clientY - startY) / bindingScale;

      dragScale = disX > disY ? disX / width : disY / height;

      const w = width * (dragScale + 1);
      const h = height * (dragScale + 1);
      const t = top - height * dragScale;
      // 如果宽高小于0 就return
      if (w < 0 || h < 0) return;
      binding.value.element.width = w;
      binding.value.element.height = h;
      binding.value.element.top = t;
    };
    clear();
  };

  // 底部中心点
  const oBottom = ele.querySelector(".bottom");
  oBottom.onmousedown = function(ev) {
    ev.stopPropagation();
    const startY = ev.clientY;
    const bindingScale = binding.value.scale;
    const { height } = binding.value.element;
    let dragScale = 0;
    document.onmousemove = function(ev) {
      ev.preventDefault();

      const disY = (ev.clientY - startY) / bindingScale;
      dragScale = disY / height;
      const h = height * (dragScale + 1);
      if (h < 0) return;
      binding.value.element.height = h;
    };
    clear();
  };

  // 顶部中心点  需要算top
  const oTop = ele.querySelector(".top");
  oTop.onmousedown = function(ev) {
    ev.stopPropagation();
    const startY = ev.clientY;
    const bindingScale = binding.value.scale;
    const { height, top } = binding.value.element;
    let dragScale = 0;
    document.onmousemove = function(ev) {
      ev.preventDefault();
      const disY = -(ev.clientY - startY) / bindingScale;
      dragScale = disY / height;
      const h = height * (dragScale + 1);
      if (h < 0) return;
      const t = top - disY;
      binding.value.element.height = h;
      binding.value.element.top = t;
    };
    clear();
  };

  // 左上角 需要算top,left
  const oTopLeft = ele.querySelector(".top-left");
  oTopLeft.onmousedown = function(ev) {
    ev.stopPropagation();
    const startX = ev.clientX;
    const startY = ev.clientY;
    const { left, top, width, height } = binding.value.element;
    const bindingScale = binding.value.scale;
    let dragScale = 0;

    document.onmousemove = function(ev) {
      ev.preventDefault();

      const disX = -(ev.clientX - startX) / bindingScale;
      const disY = -(ev.clientY - startY) / bindingScale;

      dragScale = disX > disY ? disX / width : disY / height;

      const w = width * (dragScale + 1);
      const h = height * (dragScale + 1);
      const t = top - height * dragScale;
      const l = left - width * dragScale;
      if (w < 0 || h < 0) return;
      binding.value.element.width = w;
      binding.value.element.height = h;
      binding.value.element.top = t;
      binding.value.element.left = l;
    };
    clear();
  };

  // 左边中心点 需要算left
  const oLeft = ele.querySelector(".left");
  oLeft.onmousedown = function(ev) {
    ev.stopPropagation();
    const startX = ev.clientX;
    const bindingScale = binding.value.scale;
    const { width, left } = binding.value.element;
    let dragScale = 0;

    document.onmousemove = function(ev) {
      ev.preventDefault();
      const disX = -(ev.clientX - startX) / bindingScale;

      dragScale = disX / width;
      const w = width * (dragScale + 1);
      const l = left - disX;
      if (w < 0) return;
      binding.value.element.width = w;
      binding.value.element.left = l;
    };
    clear();
  };

  // 左下角 需要算left
  const oBottomLeft = ele.querySelector(".bottom-left");
  oBottomLeft.onmousedown = function(ev) {
    ev.stopPropagation();
    const startX = ev.clientX;
    const startY = ev.clientY;
    const bindingScale = binding.value.scale;
    const { width, height, left } = binding.value.element;
    let dragScale = 0;

    document.onmousemove = function(ev) {
      ev.preventDefault();
      const disX = -(ev.clientX - startX) / bindingScale;
      const disY = (ev.clientY - startY) / bindingScale;
      dragScale = disX > disY ? disX / width : disY / height;

      const w = width * (dragScale + 1);
      const h = height * (dragScale + 1);
      if (w < 0 || h < 0) return;
      const l = left - width * dragScale;
      binding.value.element.width = w;
      binding.value.element.height = h;
      binding.value.element.left = l;
    };
    clear();
  };

  // mouseup 释放
  function clear() {
    document.onmouseup = function() {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  }
}

// export const drag1 = function() {
//   var odiv = this.el;
//   odiv.onmousedown = function(ev) {
//     var disx = ev.clientx - odiv.offsetleft;
//     var disy = ev.clienty - odiv.offsettop;
//     document.onmousemove = function(ev) {
//       var l = ev.clientx - disx;
//       var t = ev.clienty - disy;
//       odiv.style.left = l + "px";
//       odiv.style.top = t + "px";
//     };
//     document.onmouseup = function() {
//       document.onmousemove = null;
//       document.onmouseup = null;
//     };
//   };
// };
